import { FC } from 'react'
import styled from 'styled-components'
import { MessageItem } from '../../states/messageState'
import { SpeechBalloon } from '../SpeechBalloon'

type UserMessageListProps = {
  messageItem: MessageItem
}
export const UserMessageList: FC<UserMessageListProps> = (props) => {
  const { messageItem } = props
  const isFile = (message: string): message is `file:${string}` => message.includes('file:')
  const extractSrc = (message: `file:${string}`) => message.split('file:')[1]

  return (
    <StyledUserMessagesWrap>
      {messageItem.messages.map((message, index) => (
        <StyledStyledSpeechBalloonWrap key={index}>
          {isFile(message) ? (
            <img src={extractSrc(message)} alt="" width="100%" />
          ) : (
            <SpeechBalloon sender="user" isLast={index === messageItem.messages.length - 1}>
              {message}
            </SpeechBalloon>
          )}
        </StyledStyledSpeechBalloonWrap>
      ))}
    </StyledUserMessagesWrap>
  )
}

const StyledUserMessagesWrap = styled.div`
  margin-bottom: 10px;
  max-width: 75%;
`
const StyledStyledSpeechBalloonWrap = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`
